export default "__VITE_ASSET__jpRhIHa3__"